import { v4 as uuidv4 } from 'uuid';
import { getStore } from '../../factory';
import buildCollections from './buildCollections';

// Single shared implementation for "rebuild profileStore's flattened
// collections from the current active list" — every action that changes
// this.subscriptions needs to keep profileStore.collections in sync too
// (getSubscriptions, unsubscribe, mergeLatestSubscription).
function refreshProfileCollections(activeSubs) {
    const profileStore = getStore('profile');
    if (!profileStore) return;
    profileStore.collections = buildCollections(activeSubs);
    profileStore.observed.collections = uuidv4();
}

export default refreshProfileCollections;
